import { useTheme } from '@react-navigation/native';
import React from 'react';
import { View, StyleSheet, Dimensions, FlatList, ScrollView, Platform } from 'react-native';
import Animated, {
  interpolate,
  useAnimatedRef,
  useAnimatedStyle,
  useScrollViewOffset,
} from 'react-native-reanimated';
import { useCssStyle } from '../../customHook/getCssStyle';

const { width } = Dimensions.get('window');
const HEADER_HEIGHT = 393;

const ParallaxScrollView = (props) => {
  const { 
    children, 
    headerImage, 
    style,
    contentContainerStyle = {},

    ...restProps
  } = props;
  
  const backgroundColor = useTheme({}, 'background');
  const getStyles = useCssStyle();

  // const mainContainerPaddingBottom = useMemo getStyles("mainContainerWidgetsContainer")?.paddingBottom || 148;
  
  const scrollRef = useAnimatedRef();
  const scrollOffset = useScrollViewOffset(scrollRef);
  
  const headerAnimatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          scale: interpolate(
            scrollOffset.value,
            [-HEADER_HEIGHT, 0, HEADER_HEIGHT],
            [2, 1, 1]
          ),
        },
      ],
    };
  }, []);


  return (
    <View style={{ flex: 1 }}>
      <Animated.View
        style={[
            getStyles([
                "parallaxRootContainerHeaderContainer",
                { height: HEADER_HEIGHT }
            ]),
            headerAnimatedStyle,
        ]}
      >
        {typeof headerImage === 'function' ? headerImage() : headerImage}
      </Animated.View>

      <ScrollView 
        ref={scrollRef} 
        style={{ flex: 1 }}
        contentContainerStyle={{
          marginTop: HEADER_HEIGHT - 20,
          paddingBottom: Platform.OS === 'web' ? 0 : HEADER_HEIGHT - Math.abs(HEADER_HEIGHT - 148),
          ...contentContainerStyle,
          minHeight: "100%"
        }} 
        showsVerticalScrollIndicator={false}
      >
        {children}
      </ScrollView>
    </View>
  );
};

export default ParallaxScrollView;